import { Utils } from "@lightningjs/sdk";
const asset = (name) => Utils.asset(`images/hero/${name}.png`);
const team = (name, logo, logoWidth, logoHeight = 87) => ({
    name,
    logoSrc: Utils.asset(`images/hero/logo-${logo}.svg`),
    logoWidth,
    logoHeight,
});
const player = (name, x, y, w, h) => ({ src: asset(`player-${name}`), x, y, w, h });
export function heroGames(href) {
    // Fixture dates and countdowns are the pitch design's demo content.
    const countdownStartedAt = Date.now();
    const startsIn = (hours, minutes, seconds) => countdownStartedAt + (hours * 3600 + minutes * 60 + seconds) * 1000;
    const common = { timezone: "CEST", route: "subscribe/ligue-1" };
    return [
        Object.assign(Object.assign({}, common), { home: team("PSG", "psg", 87), route: "watch-details", href, away: team("Marseille", "marseille", 87), date: "22 October", kickoff: "21:00", live: true, fadePlayers: true, players: [
                player("marseille", 737, 82, 831, 998),
                player("psg", 949, 45, 893, 1035),
            ], scoreBanner: {
                homeLogoSrc: Utils.asset("images/hero/score-logo-psg.svg"),
                awayLogoSrc: Utils.asset("images/hero/score-logo-marseille.svg"),
                homeScore: 2,
                awayScore: 1,
                round: "Ligue",
                venue: "CEPAC Vélodrome",
            } }),
        Object.assign(Object.assign({}, common), { home: team("Brest", "brest", 72), away: team("OGC Nice", "nice", 70), date: "23 October", kickoff: "19:45", players: [
                player("nice", 1167, 138, 589, 822),
                player("brest", 823, 106, 613, 1027),
            ], scoreBanner: {
                homeLogoSrc: Utils.asset("images/hero/logo-brest.svg"),
                awayLogoSrc: Utils.asset("images/hero/logo-nice.svg"),
                homeLogoWidth: 123,
                awayLogoWidth: 121,
                round: "Ligue",
                venue: "Stade Francis-le Blé",
                startsAt: startsIn(23, 59, 21),
            } }),
        Object.assign(Object.assign({}, common), { home: team("RC Lens", "lens", 65), away: team("Paris FC", "paris-fc", 73), date: "24 October", kickoff: "19:45", players: [
                player("paris-fc", 1153, 138, 665, 1009),
                player("lens", 769, 61, 740, 968),
            ], scoreBanner: {
                homeLogoSrc: Utils.asset("images/hero/logo-lens.svg"),
                awayLogoSrc: Utils.asset("images/hero/logo-paris-fc.svg"),
                homeLogoWidth: 111.322,
                awayLogoWidth: 125.023,
                round: "Ligue",
                venue: "Stade Bollaert-Delelis",
                startsAt: startsIn(47, 59, 21),
            } }),
        Object.assign(Object.assign({}, common), { home: team("AS Monaco", "monaco", 50.163), away: team("LOSC", "lille", 87, 83), date: "25 October", kickoff: "14:00", players: [
                player("lille", 826, 126, 556, 1313),
                player("monaco", 1157, 97, 789, 1062),
            ], scoreBanner: {
                homeLogoSrc: Utils.asset("images/hero/score-logo-monaco.svg"),
                awayLogoSrc: Utils.asset("images/hero/logo-lille.svg"),
                homeLogoWidth: 85.911,
                awayLogoHeight: 142.149,
                round: "Ligue",
                venue: "Stade Louis II",
                startsAt: startsIn(70, 59, 21),
            } }),
        Object.assign(Object.assign({}, common), { home: team("Angers SCO", "angers", 73), away: team("FC Lorient", "lorient", 61), date: "25 October", kickoff: "16:15", players: [
                player("lorient", 640, 85, 821, 1037),
                player("angers", 878, 101, 1014, 1049),
            ], scoreBanner: {
                homeLogoSrc: Utils.asset("images/hero/logo-angers.svg"),
                awayLogoSrc: Utils.asset("images/hero/logo-lorient.svg"),
                homeLogoWidth: 125.023,
                awayLogoWidth: 104.471,
                round: "Ligue",
                venue: "Stade Raymond-Kopa",
                startsAt: startsIn(72, 59, 21),
            } }),
    ];
}
export default heroGames;
//# sourceMappingURL=heroGames.js.map